import React from 'react'
import './css/app1.css'
import social1 from './images/social1.png'
import social2 from './images/social2.png'
import social3 from './images/social3.png'
import social4 from './images/social4.png'

export default function MainFooter() {
  return (
    <>
    <div className="mainFooterbac">
    <div className="container mainfooter">
        <div className="row row-cols-2">
            <div className="col mainfooterItem1">
                <ul class="mainFooterList">
                    <li>Sitemap</li>
                    <li>Terms</li>
                    <li>Privacy Notice</li>
                    <li>@ 2026 RAJ Digital Marketing,All Right Reserved</li>
                </ul>
            </div>
            <div className="col Footericon1">
            <div className="follow-us-section-icon1">
                    <ul className='social-icon14' >
                  <i><a href="https://www.linkedin.com/company/raj-digital-marketing-fz-llc/posts/?feedView=all"><img src={social1} alt="" /></a></i>   
                                   {/* <i><img src={social2} alt="" /></i>    */}
                                   <i><a href="https://www.facebook.com/rajdigitalmarketingagency/"><img src={social3} alt="" /></a></i>   
                                   <i><a href="https://www.instagram.com/rajdigitalmarketing/"><img src={social4} alt="" /></a></i> 
                  </ul> 
                 </div>
            </div>
        </div>
    </div>
    </div>
    
    </>
  )
}
